<template>
  <li
    class="list-group-item py-5"
    :class="{ 'bg-light': ownComment }"
  >
    <div
      class="media"
    >
      <div class="media-body">
        <div class="media-heading">
          <time-ago
            class="float-right text-muted small ml-2"
            :refresh="60"
            :datetime="Date.parse(commentItem.created+ 'Z')"
            locale="en"
          />
          <div
            v-if="hasAnnotation"
            class="annotation"
          />
          <h6
            class="word-break"
            data-test="commenter-email"
            :class="{ 'pl-5': hasAnnotation }"
          >
            {{ commentItem.commenterEmail }}
          </h6>
        </div>
        <div data-test="commenter-feedback">
          {{ commentItem.comment }}
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import { mapState } from 'vuex';
import TimeAgo from 'vue2-timeago';

export default {
  name: 'CommentItem',
  components: {
    TimeAgo,
  },
  props: {
    commentItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('account', {
      accountEmail: 'email',
    }),
    ownComment() {
      return this.accountEmail === this.commentItem.commenterEmail;
    },
    hasAnnotation() {
      return (this.commentItem.commentLocation);
    },
  },
  methods: {
  },
  created() {
  },
};
</script>
<style>
.media-body{
  max-width: 100%;
}
.word-break{
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.v-time-ago__text{
  cursor: default;
}
</style>
